'use client';

import { measure } from '@/components/Analytics/Analytics';
import { HeaderButton } from '@/components/Header/Header';
import { mdiPlusThick } from '@mdi/js';
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

const AIMachineHeaderButton = () => {
    const [isClient, setIsClient] = useState(false);

    useEffect(() => setIsClient(true), []);

    if (!isClient) return null;

    const headerPortal = document.getElementById('header-portal');

    if (!headerPortal) return null;

    return ReactDOM.createPortal(
        <HeaderButton
            isPrimary
            label="nieuwe maken"
            icon={mdiPlusThick}
            onClick={() => {
                measure('media_machine_header_button_new');
                confirm('Weet je zeker dat je een nieuwe AI Machine wil maken?')
                    ? location.reload()
                    : undefined;
            }}
        />,
        headerPortal,
    );
};

export default AIMachineHeaderButton;
